import { render } from "./expense-category.vue?vue&type=template&id=167561e6"
import script from "./expense-category.vue?vue&type=script&lang=js"
export * from "./expense-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__